<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordoglo/svgGlo11bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 87px; top: 75px">
      <p>Señala dónde está escrito el nombre del animal.</p>
    </span>
    
    <div id="radio1">
      <label class="toggleButtonContainer pageElement" id="toggle11"
        >TORTA
        <input type="radio" name="torta" 
        ref="1-1" 
        v-on:change="saveOption('radios', 1, 1)" 
        :onload="loadOption('radios', 1, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle12"
        >TORTUGA
        <input type="radio" name="torta" 
        ref="1-2" 
        v-on:change="saveOption('radios', 1, 2)"
        :onload="loadOption('radios', 1, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle13"
        >TORMENTA
        <input type="radio" name="torta" 
        ref="1-3" 
        v-on:change="saveOption('radios', 1, 3)"
        :onload="loadOption('radios', 1, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio2">
      <label class="toggleButtonContainer pageElement" id="toggle21"
        >PASTO
        <input type="radio" name="pasto" 
        ref="2-1" 
        v-on:change="saveOption('radios', 2, 1)" 
        :onload="loadOption('radios', 2, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle22"
        >PATO
        <input type="radio" name="pasto" 
        ref="2-2" 
        v-on:change="saveOption('radios', 2, 2)" 
        :onload="loadOption('radios', 2, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle23"
        >PALO
        <input type="radio" name="pasto" 
        ref="2-3" 
        v-on:change="saveOption('radios', 2, 3)" 
        :onload="loadOption('radios', 2, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <img id="toad" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo11Toad.svg">
    <img id="tortoise" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo8TortoiseFlip.svg" />
    <img id="duck" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo7DuckFlip.svg">


    <div class="textBubble" style="width:377px; height: 253px; left: 541px; margin-top: 410px;">
      <div class="textContainer textBase center" style="width: 90%; height: 90%;">
        <p class="center">
          ¡Presta atención!<br>
          <br>
          Las palabras son muy similares y las puedes confundir.
        </p>
      </div>
      <img class="arrow" src="/pages/img/general/textBubbleArrowLeft.svg" style="top: 245px; left:210px;"/>
    </div>

    <!--- FOOTER --->
    <span class="footer-page footer-read"></span>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 223px;
  top: 192px;
}
#toggle11 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 186px;
}
#toggle12 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 240px;
}
#toggle13 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 293px;
}
#toggle21 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 497px;
}
#toggle22 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 551px;
}
#toggle23 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 604px;
}
#toad{
    position: absolute;
    left: 43px;
    top: 209px;
}
#tortoise{
    position: absolute;
    left: 483px;
    top: 209px;
}
#duck{
    position: absolute;
    left: 43px;
    top: 489px;
}
.textBubble p {
  font-size: 30px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>